import React, { useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toastmodal from "../Toastmodal";
import { useAuthHandling } from '../useAuthhandling';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Allimagestyle from "./Allimage_style";
import Allimageselect from "./Allimageselect";

function Blogadd() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);

  const [selectedImageId, setSelectedImageId] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);


  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [description,setDescription]=useState([]);
  const [blog, setBlog] = useState({
    title: "",
    image: "",
    slug: "",
    publishDate: "",
    status: true,
    draft:true
  });
  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setBlog({ ...blog, [name]: value });
  };


  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setDescription(data);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = "Title is required!";
    }
    // if (!values.slug) {
    //   errors.slug = "Slug is required!";
    // }
    if (!values.metatitle) {
      errors.metatitle = "Meta title is required!";
    }
    if (!values.metadescription) {
      errors.metadescription = "Meta description is required!";
    }
    if (selectedImageId.length===0) {
      errors.image = "Image is required!";
    } 
    // else {
    //   if (
    //     values.image.type === "image/jpeg" ||
    //     values.image.type === "image/jpg" ||
    //     values.image.type === "image/png"
    //   ) {
    //     if (values.image.size > 1024 * 1000) {
    //       errors.image =
    //         "maximum file size 1 mb...please upload an image less than 1 mb";
    //     }
    //   } else {
    //     errors.image = "Only support jpg, jpeg, png image!";
    //   }
    // }
    if (!values.publishDate) {
      errors.publishDate = "PublishDate is required!";
    }

    return errors;
  };


  const validatedes = (values) => {
    const errors = {};
    if (!values) {
      errors.description = "Description is required!";

    }
    return errors;
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setBlog({ ...blog, [name]: e.target.files[0] });
  };
  const PostData = async (e) => {
    e.preventDefault();
    const { title, image, slug, publishDate } = blog;
    const ress = validate(blog);
    const ressdes = validatedes(description);


    setError(ress);
    setError1(ressdes);
    if (
      !ress.title &&
      !ressdes.description &&
      !ress.image &&
      // !ress.slug &&
      !ress.publishDate &&
      !ress.metatitle &&
      !ress.metadescription

    ) {
      // const formData = new FormData();
      // formData.append("title", blog.title);
      // formData.append("description", description);
      // formData.append("blogImg", blog.image);
      // formData.append("slug", blog.slug);
      // formData.append("status", blog.status);
      // formData.append("authorType", "admin");
      // formData.append("metaTitle", blog.metatitle);

      // formData.append("metaDescription", blog.metadescription);

      // formData.append("publishDate", blog.publishDate);

      const data = {
        title: blog.title,
        description: description,
        blog_images: selectedImageId.map((img) => img.id),
        slug: blog.slug,
        status:blog.status,
        draft:blog?.draft,
        authorType:"admin",
        metaTitle:blog.metatitle,
        metaDescription: blog.metadescription,
        publishDate: blog.publishDate
      };
      axios
        .post(`${Config.apiurl}/api/v1/crm/blog/create`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200 ) {
            setToastmodal(true);
            setToastmessage("Sucessfully Created Blog");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);

          
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage(res.message);
            setToasttype("error");
          }
        });
    }
  };

console.log(blog);
  return (
    <>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Blog Table</h4>
                      <p className="card-description">Add New Blog</p>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Title"
                            name="title"
                            value={blog.title}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.title}
                          </label>
                        </div>
                        <div className="form-group ck_edit_cls">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>

                          <CKEditor
                    editor={ ClassicEditor }    
                    data={description}
                    onChange={handleEditorChange}               
                  
                />                          {/* <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Description"
                            name="description"
                            value={blog.description}
                            onChange={handleInputs}
                          /> */}
                          <label style={{ color: "red" }}>
                            {formerror1.description}
                          </label>
                        </div>
                        {/* <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Slug</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Slug"
                            name="slug"
                            value={blog.slug}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.slug}
                          </label>
                        </div> */}
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            publishDate
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="PublishDate"
                            name="publishDate"
                            value={blog.publishDate}
                            onChange={handleInputs}
                            onClick={(e) => e.target.showPicker()}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.publishDate}
                          </label>
                        </div>
                      
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Status</label>

                            <select
                              className="form-control"
                              style={{
                                color: "black",
                                backgroundColor: "#2b2e4c;",
                              }}
                              id="exampleInputUsername1"
                              name="status"
                              onChange={handleInputs}
                            >
                              <option
                                id="exampleInputUsername1"
                                name="status"
                                value="true"
                              >
                                Active
                              </option>
                              <option
                                id="exampleInputUsername1"
                                name="status"
                                value="false"
                              >
                                In Actve
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Draft / Publish</label>

                            <select
                              className="form-control"
                              style={{
                                color: "black",
                                backgroundColor: "#2b2e4c;",
                              }}
                              id="exampleInputUsername1"
                              name="draft"
                              onChange={handleInputs}
                            >
                              <option
                                id="exampleInputUsername1"
                                name="draft"
                                value="true"
                              >
                                Draft
                              </option>
                              <option
                                id="exampleInputUsername1"
                                name="draft"
                                value="false"
                              >
                                Publish
                              </option>
                            </select>

                          </div>
                        </div>
                      </div>


                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Meta Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Meta title"
                            name="metatitle"
                            value={blog.metatitle}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.metatitle}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                           Meta Descriptiom
                          </label>
                          <textarea
                            rows="5"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Meta description"
                            name="metadescription"
                            value={blog.metadescription}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.metadescription}
                          </label>
                        </div>


                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            Image (400px * 340px)
                          </label>
                          <br></br>
                          {/* <input
                            type="file"
                            name="image"
                            onChange={onFileChange}
                          /> */}

                          <Allimagestyle selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                         
                        </div>
                        <Allimageselect selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>
                      
                        <label style={{ color: "red" }}>
                            {formerror.image}
                          </label>
                          <br></br>
                        <button
                          type="submit"
                          style={{ marginTop:"10px"}}
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Blogadd;
